import AddCircleIcon from "@mui/icons-material/AddCircle";
import FileCopyOutlinedIcon from "@mui/icons-material/FileCopyOutlined";
import { Box, Stack, useTheme } from "@mui/material";
import { useAtom } from "jotai";
import { selectAtom } from "jotai/utils";
import React, { useState } from "react";
import IwButtonDropdown from "../../components/app/IwButtonDropdown";
import MaterialModal from "../../components/app/material-modal";
import MaterialInterviewDetails from "../../components/discovery/interview/material-interview-details";
import TemplateCreationForm from "../../components/discovery/template/TemplateCreationForm";
import { baseAtom } from "../../stores/jotai/base";
import CustomNavigationAndUploadsHandler from "./custom-navigation-handler";

const userAtom =  selectAtom(baseAtom, (base) => base?.user)
const teamAtom =  selectAtom(baseAtom, (base) => base?.team)

const AppCreateButton = () => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [isInterviewCreationModalOpen, setIsInterviewCreationModalOpen] =
        useState<boolean>(false);
    const [isTemplateCreationModalOpen, setIsTemplateCreationModalOpen] =
        useState<boolean>(false);
    const [base, setBase] = useAtom(baseAtom);
    const muiTheme = useTheme();
    const isTeamMember = base.roleSnapshot.isTeamMember;

    const open = Boolean(anchorEl);
    const [team] = useAtom(teamAtom);
    const [user] = useAtom(userAtom);    const theme = useTheme();
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleInterviewModalClose = () => {
        setIsInterviewCreationModalOpen(false);
        setAnchorEl(null);
    }

    const handleTemplateModalClose = () => {
        setIsTemplateCreationModalOpen(false);
        setAnchorEl(null);
    }

    const dropdownItems = [
        {
            content: (
                <Stack
                    direction="row"
                    alignItems="center"
                >
                    <AddCircleIcon
                        sx={{
                            marginRight: "4px",
                            fontSize: "24px",
                            color: muiTheme?.palette?.primary?.main,
                            opacity: isTeamMember ? 1 : 0.5,
                        }}
                    />
                    Create Interview
                </Stack>
            ),
            onClick: () => {
                setIsInterviewCreationModalOpen(true);
            },
        },
        {
            content: (
                <Stack
                    direction="row"
                    alignItems="center"
                >
                    <FileCopyOutlinedIcon
                        sx={{ marginRight: "8px", color: theme?.custom?.mainIconColor }}
                    />{" "}
                    Create Interview Template
                </Stack>
            ),
            onClick: () => {
                setIsTemplateCreationModalOpen(true);
            },
        },
        {
            content: (
                <CustomNavigationAndUploadsHandler
                    user={base?.user}
                    team={base?.team}
                    appState={base?.appState}
                    justRenderMenu={true}
                    onInterviewModalClose={() => {
                        setAnchorEl(null);
                    }}
                />
            ),
            disableMenuItemWrapper: true,
        },
    ];

    return (
        <>
            <Box sx={{ marginRight: "8px !important" }}>
                <IwButtonDropdown
                    slotProps={{
                        buttonGroup: {
                            disabled: !isTeamMember,
                        },
                        dropdownButton: {
                            disabled: !isTeamMember,
                            onClick: handleClick,
                        },
                        menu: {
                            onClose: handleClose,
                            open,
                            anchorEl,
                        },
                    }}
                    dropdownItems={dropdownItems}
                    shape="rounded"
                />
            </Box>
            <CustomNavigationAndUploadsHandler
                user={base?.user}
                team={base?.team}
                appState={base?.appState}
                onInterviewModalClose={() => {
                    setAnchorEl(null);
                }}
            />
            <MaterialModal
                title="Create Interview"
                open={isInterviewCreationModalOpen}
                onClose={handleInterviewModalClose}
                handleDialogClose={handleInterviewModalClose}
                styleOverrides={{
                    container: {
                        "& .MuiDialog-paper": {
                            width: "100%",
                            minHeight: "500px",
                            minWidth: "780px",
                        },
                    },
                }}
            >
                <MaterialInterviewDetails
                    showSaveAndOpenButton={true}
                    style={{ width: "812px" }}
                    interview={{}}
                    import={undefined}
                    existingInterview={false}
                    audioImportDoneUploading={true}
                    close={handleInterviewModalClose}
                    errors={{}}
                    handleErrors={() => {}}
                    setBase={setBase}
                />
            </MaterialModal>
            <MaterialModal
                title="Create Template"
                open={isTemplateCreationModalOpen}
                onClose={handleTemplateModalClose}
                handleDialogClose={handleTemplateModalClose}
                styleOverrides={{
                    container: {
                        "& .MuiDialog-paper": {
                            width: "100%",
                            minWidth: "812px",
                        },
                    },
                }}
            >
                <TemplateCreationForm
                    showSaveAndOpenButton={true}
                    onClose={handleTemplateModalClose}
                    onSuccess={handleTemplateModalClose}
                    team={team}
                    user={user}
                    setBase={setBase}
                />
            </MaterialModal>
        </>
    );
};

export default AppCreateButton;
